export const DEFAULT_MEMORY_LOGGING_THRESHOLDS = {
  listenerCount: 60000,
  timerCount: 550,
  observerCount: 2500
};
export function resolveMemoryLoggingThresholds(config) {
  // Memory logging is on by default: an unset config resolves to the default
  // thresholds, matching apps that previously opted in with `true`. Pass
  // `false` to opt out.
  if (config === false) return undefined;
  if (config === undefined || config === true) return DEFAULT_MEMORY_LOGGING_THRESHOLDS;
  return config;
}